import { find, findAll } from "../utils/dom";

const EditorJS = () => {

	const EditorSimples = findAll("[js-editor-simples]");

	/** Para adicionar texto no front de maneira simples */
	if (EditorSimples) {
		EditorSimples.forEach((editor) => {
			if (editor.textContent) {
				let Texto = JSON.parse(editor.textContent);
				let ResultText = '';
				let TotalParagraph = Texto.blocks.length

				for (let i = 0; i < TotalParagraph; i++) {
					if (TotalParagraph > 0) {
						ResultText += `${Texto.blocks[i].data.text} <br />`;
					}
					else {
						ResultText = `${Texto.blocks[i].data.text}`;
					}


				}

				editor.innerHTML = ResultText;
			}
			//editor.innerHTML = Texto.blocks[0].data.text;
		})
	}


	function makerEditorTags(editor, caracter_final = ''){
		
		if (editor.textContent) {
			try{
				let Texto = JSON.parse(editor.textContent);
				let ResultText = '';
				let TotalTag = Texto.blocks.length;
				

				for (let i = 0; i < TotalTag; i++) {
					const Tipo = Texto.blocks[i].type;
					//console.log(Texto.blocks[i])

					switch (Tipo) {

						case 'paragraph':
							ResultText += `<p>${Texto.blocks[i].data.text}</p>${caracter_final}`
							break;

						case 'Header':
							const Level = Texto.blocks[i].data.level
							ResultText += `<h${Level}>${Texto.blocks[i].data.text}</h${Level}>${caracter_final}`;
							break;

						case 'List':
							ResultText += `<ul class='${Texto.blocks[i]?.data?.style}'>`
							const Itens = Texto.blocks[i].data.items;

							for (let k of Itens) {
								ResultText += `<li>${k}</li>`
							}
							ResultText += `</ul>`
							break;

						case 'Image':
							ResultText += `<img src='${Texto.blocks[i].data.file.url}' />`
							break;

						case "Duas colunas":
							ResultText += `
								<div class='grid grid-cols-2 md:grid-cols-1 gap-[4rem] xl2:gap-[3rem] md:gap-[1rem] w-full'>
									<div>
										${Texto.blocks[i].data?.left}
									</div>
									<div>
										${Texto.blocks[i].data?.right}
									</div>
								</div>
							`
						break;

						case "Alinhar texto":
							ResultText += `
								<div class="text-end">

									
									${Texto.blocks[i].data.text}
								</div>
							`
						break;

						case "Quote":
							ResultText += `
								<blockquote>
									${Texto.blocks[i].data.text}
									${(Texto.blocks[i].data.caption != "<br>")?"<cite>"+Texto.blocks[i].data.caption+"</cite>":''}
								</blockquote>
							`
						break;
					}



				}

				editor.innerHTML = ResultText;
			}catch(e){
				//console.log(`erro: ${e}`)
			}
		}
	}



	document.addEventListener("DOMContentLoaded", ()=>{
		const EditorTags = findAll("[js-editor-tags]");
		if (EditorTags) {
			EditorTags.forEach((editor) => {
				makerEditorTags(editor);
			})
		}
	})

	const bts = findAll("[js-bt-editor]");
	bts?.forEach((bt)=>{
		bt.addEventListener("click", (e)=>{
			const alvo = e.target.getAttribute('js-bt-editor');

			
			const editor = find(`[js-alvo-editor='${alvo}'].loadingEditor`);

			if(editor){
				setTimeout(() => {
					makerEditorTags(editor);
				}, 300);

				if(!e.target.hasAttribute('js-att')){
					editor.classList.remove("loadingEditor");
				}
			}
		})
	})	


	

}

export default EditorJS;